import { parseUnits } from "viem";
import { slippageFloor } from "./format";

export interface TradePlanInput {
  direction: "BUY" | "SELL";
  side: "SHORT" | "LONG";
  collateralAmount: bigint;
  quotedOutcomeAmount: bigint;
  slippageBps: number;
}

export interface TradePlan {
  outcomeIndex: bigint;
  approvalAmount: bigint;
  tradeLimit: bigint;
}

export function buildTradePlan(input: TradePlanInput): TradePlan {
  if (input.collateralAmount <= 0n || input.quotedOutcomeAmount <= 0n) {
    throw new Error("trade amounts must be positive");
  }
  if (input.slippageBps < 0 || input.slippageBps >= 10_000) {
    throw new Error("invalid slippage");
  }
  const outcomeIndex = input.side === "SHORT" ? 0n : 1n;
  if (input.direction === "BUY") {
    return {
      outcomeIndex,
      approvalAmount: input.collateralAmount,
      tradeLimit: slippageFloor(input.quotedOutcomeAmount, input.slippageBps)
    };
  }
  return {
    outcomeIndex,
    approvalAmount: input.quotedOutcomeAmount,
    tradeLimit:
      (input.quotedOutcomeAmount * BigInt(10_000 + input.slippageBps) + 9_999n) / 10_000n
  };
}

export function percentToScalar(percent: string): bigint {
  return parseUnits(percent, 10);
}
